import React, { useState } from 'react';
import { supportTranscript } from '../../../mocks/client';

let replyCounter = 0;

/**
 * Support chat with Agent 9 (T9.5). The mock reply loop keeps the demo alive
 * without a backend; real wiring plugs into the Agent 9 channel API later.
 */
function SupportChatWindow() {
  const [messages, setMessages] = useState(supportTranscript);
  const [draft, setDraft] = useState('');

  const send = (event) => {
    event.preventDefault();
    const text = draft.trim();
    if (!text) return;

    replyCounter += 1;
    const clientMessage = { id: `s-c-${replyCounter}`, author: 'client', text, time: 'now' };
    const agentMessage = {
      id: `s-a-${replyCounter}`,
      author: 'agent',
      text: 'Got it — I’ve logged your request and looped in your account manager if anything needs a human decision.',
      time: 'now'
    };
    setMessages((current) => [...current, clientMessage, agentMessage]);
    setDraft('');
  };

  return (
    <section className="portal-card portal-chat">
      <div className="portal-card-head">
        <div>
          <h2>Agent 9 · Support</h2>
          <span>Typically replies in under a minute</span>
        </div>
        <span className="portal-pill pill-paid">online</span>
      </div>
      <div aria-label="Support conversation" className="portal-chat-log" role="log">
        {messages.map((message) => (
          <div className={`portal-chat-message from-${message.author}`} key={message.id}>
            <p>{message.text}</p>
            <time>{message.time}</time>
          </div>
        ))}
      </div>
      <form className="portal-chat-compose" onSubmit={send}>
        <label className="sr-only" htmlFor="support-draft">Message support</label>
        <input
          id="support-draft"
          onChange={(event) => setDraft(event.target.value)}
          placeholder="Ask about invoices, agents, or requests…"
          value={draft}
        />
        <button type="submit">Send</button>
      </form>
    </section>
  );
}

export default SupportChatWindow;
